// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2c37u","label":"Radio_label__1SCLg","checkMark":"Radio_checkMark__2nTi-","disabled":"Radio_disabled__IMTBU"};